import React, {createContext, useContext, useState, useEffect} from 'react'
import chartStore from './charts/chart.store'
import { enquiryStore } from './enquiry/enquiry-data'
import { taskStore } from './mytasks/task-store'
import {quoteData, newCargoData, editCargoData, cargoListData}  from './QuotationData'
import { AgmodalStore, bookingsStore, configStore, contractsStore, loginStore, routerStore } from './state/CommonState'
import Newapi from './state/new-api'
import { dtactionStore } from './dtactions/dtaction-store'
import { rtpStore } from './pricing/pricing-store'
import Api from './state/Api'
import { ServerLists } from './StaticData'
import menuListData, { clientMenuList } from './menus'
import { useMobile } from './hooks/usemobile'

const globalContext = createContext()
export const useGlobalState = () => useContext(globalContext)


export default function GlobalState ({children}) {
    const isMobile = useMobile();
    const [quoteState, setQuoteState] = useState(quoteData)
    const [newCargoDataState, setNewCargoDataState] = useState(newCargoData)
    const [editCargoDataState, setEditCargoDataState] = useState(editCargoData)
    const [cargoListState, setCargoListState] = useState(cargoListData)
    const [menuList, setMenuList] = useState([])

    useEffect(()=>{
        const fetchRolesPermissions = async () => {
            if (!loginStore.isClient() && (ServerLists.rolePermissionsList.length <= 0) && ServerLists?.permissionsList?.length <= 0) {
                await Api.getRolesPermissions();
            }
            setMenuList(menuListData)
        };
        fetchRolesPermissions();
    }, [])

    //if (loginStore.isClient()) menuList = clientMenuList

// For temporary disable dashboard screen for client login
    const [currentMenu, setCurrentMenu] = useState(
        loginStore.isClient() 
            ? 'Home'  
            : (isMobile ? 'Carting Sheet' : configStore.currentMainMenu)
    )

    const updateMainComponent = (menuKey) => {
        let menuList = menuListData
        if (loginStore.isClient()) menuList = clientMenuList
        for (let i = 0; i < menuList.length; i++) {
            if(menuList[i]['children'] != undefined && menuList[i]['children'].length>0){
                let a = 0
                for (let j = 0; j < menuList[i]['children'].length; j++) {
                    let item = menuList[i]['children'][j]
                    if(item['key']==menuKey){
                        configStore.currentMainComponent = (isMobile && item.isMobileView && item.mobileComponent) ? item.mobileComponent : item["component"]
                        j = menuList[i]['children'].length + 1
                        a=1
                    }
                }
                if(a==1){
                    i = menuList.length + 1
                }
            }else{
                let item = menuList[i]
                if(item['key'] === menuKey){
                    configStore.currentMainComponent = (isMobile && item.isMobileView && item.mobileComponent) ? item.mobileComponent : item["component"]
                    i = menuList.length+1
                }
            }
        }
    }

    useEffect(() => {
        const activeMenu = (isMobile && !loginStore.isClient() && (currentMenu === 'Dashboard' || !currentMenu)) 
            ? 'Carting Sheet' 
            : currentMenu;
        if (activeMenu) {
            updateMainComponent(activeMenu);
        }
    }, [isMobile, currentMenu]);

    const changeCurrentMenu = (menu) => {
        AgmodalStore.apiCall = true
        configStore.quoteCurrentView = 'list'
        configStore.quoteapprovalCurrentView = 'list'
        configStore.requestapprovalCurrentView = 'list'
        configStore.raterequestCurrentView = 'list'
        configStore.dtCurrentView = 'list'
        routerStore.agusersCurrentView = 'list'
        routerStore.entityCurrentView = 'list'
        routerStore.entityCurrentViewNew = 'list'
        routerStore.driverCurrentView = 'list'
        routerStore.vehicleCurrentView = 'list'
        routerStore.branchCurrentView = 'list'
        routerStore.creditApplicationView = 'list'
        routerStore.rolesCurrentView = 'list'
        configStore.quoteClientCurrentView = 'list'
        configStore.homescreenCurrentView = 'list'
        enquiryStore.currentEnquiryListComponent = 'list'
        bookingsStore.currentBookingsListComponent = 'list'
        dtactionStore.view = 'list'
        rtpStore.markupView = 'list'
        rtpStore.airmarkupView = 'list'
        chartStore.activeProduct = 'LCL'
        taskStore.triggerActionVisible = false
        if (contractsStore.lockedContract.length > 0) {
            Newapi.releaseContractLock(contractsStore.lockedContract)
            contractsStore.lockedContract = ''
        }
        let menuList = menuListData
        if (loginStore.isClient()) menuList = clientMenuList
        if(loginStore.isClient() && menu=="Enquiries"){
            configStore.homescreenCurrentShipmentType = "LCL"
            configStore.homescreenCurrentView = 'new'
        }
        console.log('SETTING CURRENT MENU=',loginStore.isClient(), menu, menuList.length)
        setCurrentMenu(menu)
        updateMainComponent(menu);
        // configStore.currentMainComponent = menuList.filter(m => m.name === menu ).map(m => m.component)
        console.log('NEW SET CURRENT COMPONENT=', ''+configStore.currentMainComponent)
    }



    
    const [name, setName] = useState('Uma')
    const [email, setEmail] = useState('')
    const [leftMenuHidden, setLeftMenuHidden] = useState(false)
    const shipmentTypes = [
        '','LCL Export','LCL Import','FCL Export (Factory Stuffing)',
        'FCL Export (Dock Stuffing)','FCL Import','Air Export','Air Import'
    ]
    const shipmentScopes = [
        '','Port-to-Port', 'Port-to-Door', 'Door-to-Port', 'Door-to-Door'
    ]
    useEffect(() => {
        // Update the document title using the browser API
        console.log('Value of email changed=', email)
      }, [email]);
    return (
        <globalContext.Provider value={
            {
                name, setName, 
                email, setEmail,
                leftMenuHidden, setLeftMenuHidden,
                shipmentTypes, shipmentScopes,
                menuList, clientMenuList, currentMenu, setCurrentMenu, changeCurrentMenu,
                quoteState, setQuoteState,
                newCargoDataState, setNewCargoDataState,
                editCargoDataState, setEditCargoDataState, 
                cargoListState, setCargoListState
            }}>
            {children}
        </globalContext.Provider>
    )
}

